import axios from 'axios';

export default class Axios {
	constructor() {
		this.axios = axios.create();
	}
}
